import { render, staticRenderFns } from "./vuecommjhcs.vue?vue&type=template&id=7b4770ee&scoped=true"
import script from "./vuecommjhcs.vue?vue&type=script&lang=js"
export * from "./vuecommjhcs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4770ee",
  null
  
)

export default component.exports